import React from 'react'
import { BaasIllustrationBuble } from '../../svg/BaasIllustrationBuble'
import { registerRedirect } from '../../utils/router'
import { Button } from '../atoms/Button'

export const LastSection = () => {
    return (
        <div className="snap-start w-full min-h-screen flex items-center justify-center py-[50px]">
            <div className="max-w-screen-xl w-full mx-auto flex flex-col justify-center items-center">
                <div className="relative w-full max-w-screen-sm h-[calc(100vh-100px)] max-h-[calc(100vh-100px)] cursor-pointer scale-50 md:scale-75 xl:scale-100">
                    <div className="absolute top-1/4 w-full text-center flex flex-col items-center">
                        <div className="font-sansCondensed text-3xl sm:text-4xl lg:text-5xl xl:text-7xl font-black">
                            Instantly
                        </div>
                        <div className="font-sansCondensed text-2xl sm:text-3xl lg:text-4xl xl:text-6xl font-black mt-2">
                            send your first bot.
                        </div>
                        <Button
                            flatbutton={false}
                            buttonClass="w-fit mx-auto mt-4 cursor-pointer"
                            name="Get your key"
                            onClick={registerRedirect}
                            color="green"
                            textColor="text-neutral-900"
                        />
                    </div>
                    <div className="h-[calc(100vh-100px)] w-full flex items-center justify-center">
                        <BaasIllustrationBuble />
                    </div>
                </div>
            </div>
        </div>
    )
}
